<!--
 * @description: 视频框 居中播放
 * @Author: Jay
 * @Date: 2021-09-24 11:50:49
 * @LastEditors: Jay
 * @LastEditTime: 2021-10-11 16:51:55
-->
<template>
  <div>
    <video
      id="popVideo"
      :preload="preload"
      :poster="videoImg"
      align="center"
      :controls="controls"
      style="object-fit: fill"
      class="video-code"
    >
      <source :src="videoSrc" type="video/mp4" />
    </video>
  </div>
</template>

<script>
export default {
  name: "centerVideo",
  props: {
    // 视频地址
    videoUrl: {
      // type: String,
      default: "",
    },
    // 视频图片
    videoImg: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      // 视频
      videoSrc: "",
      //   videoImg:"",
      //  width: "1920", // 设置视频播放器的显示宽度（以像素为单位）
      //  height: "800", // 设置视频播放器的显示高度（以像素为单位）
      preload: "auto", //  建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
      controls: true, // 确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
      autoplay: "muted", // 自动播放属性,muted:静音播放
    };
  },
  mounted() {
    // console.log("视频地址", this.videoUrl);
    this.videoSrc = this.$api + this.videoUrl;
    // this.videoInit();
    // console.log(this.videoData.brand_shipin);
  },
  methods: {
    videoInit() {
      // 播放视频
      this.videoSrc = this.$api + this.videoUrl;
      let vd = document.getElementById("popVideo");
      vd.src = this.videoSrc;
      vd.play();
      console.log(this.videoSrc);
    },
  },
};
</script>

<style lang="scss" scoped>
.video-code {
  width: 100%;
  height: 600px;
}
</style>
